<template>
    <div class="">
        <div class="tw-text-infinity-tertiary-text tw-text-xs">{{title}}</div>
        <div class="tw-text-infinity-primary-text"><slot>{{value}}</slot></div>
    </div>
</template>
<script>
    export default {
        name: 'BasePanelItem',
        props: {
            title: {
                type: String,
                default: ''
            },
            value: {
                type: String,
                default: ''
            },
        },
    }
</script>
<style>
.panel-item + .panel-item {
    margin-top: 0.5rem;
}
</style>
